export interface Aircraft {
  id?: string;
  name?: string;
  modelKey: string;
  licenseKey?: string;
  description?: string;
  unitNumber: string;
}

export type UnassignableReason =
  | 'modelNotKnown'
  | 'licenseKeyMissingForTrinity'
  | 'valid'
  | 'alreadyAssignedToCompany';

export enum ReasonEnum {
  ModelNotKnown = 'modelNotKnown',
  LicenseKeyMissingForTrinity = 'licenseKeyMissingForTrinity',
  Valid = 'valid',
  AlreadyAssignedToCompany = 'alreadyAssignedToCompany',
}

export interface UnassignableAircraft extends Aircraft {
  reason: UnassignableReason;
  reasonDetails?: string | null;
}
export interface AircraftsRegistrationPlan {
  companyId: string;
  aircrafts: Aircraft[];
  dryRun: boolean;
}
export interface AircraftsRegistrationResponse {
  aircraft: Aircraft;
  reason: UnassignableReason;
  reasonDetails?: {
    companyId: string;
  };
}

export interface CombineAircraftAndUnassignableAircraft
  extends Omit<UnassignableAircraft, 'reason'> {
  reason?: UnassignableReason;
}
